import AuthForm from '../components/auth/AuthForm'

function AuthPage () {
  return <AuthForm />
}
export default AuthPage